import { documentRoutes, documentNavigationItems } from "./router";
export class DocumentModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[DocumentModule] Registered");
        return {
            id: "document",
            name: "Document Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return documentRoutes;
    }
    getNavigationItems() {
        return documentNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[DocumentModule] Unregistered");
        this.contracts = null;
    }
}
export default new DocumentModule();
